(function () {

    'use strict';

    /**
     * Initiates the presentable navigation.
     */
    const PresentableNavigation = function (element) {

        this.element = element;
        this.triggers = element.getElementsByClassName('js-present-nav--trigger');
        this.breakpoint = matchMedia('(min-width: 64rem)');

        this.presentNavigation = this.presentNavigation.bind(this);
        this.dismissNavigation = this.dismissNavigation.bind(this);

        this.initiateListener();
    }

    /**
     * Initiates the event listener.
     */
    PresentableNavigation.prototype.initiateListener = function () {

        for (const trigger of this.triggers) {

            trigger.firstElementChild.addEventListener('mouseenter', this.presentNavigation);
            trigger.firstElementChild.addEventListener('keydown', this.presentNavigation);
        }
    }

    /**
     * Presents the navigation.
     */
    PresentableNavigation.prototype.presentNavigation = function (event) {

        for (const trigger of this.triggers) {
            trigger.firstElementChild.setAttribute('aria-expanded', 'false');
        }

        event.target.setAttribute('aria-expanded', 'true');

        event.target.addEventListener('mouseleave', this.dismissNavigation);
        window.addEventListener('pointerdown', this.dismissNavigation);
        window.addEventListener('keyup', this.dismissNavigation);
        this.breakpoint.addEventListener('change', this.dismissNavigation);

        event.target.nextElementSibling.addEventListener('mouseleave', this.dismissNavigation);
    }

    /**
     * Dismisses the navigation.
     */
    PresentableNavigation.prototype.dismissNavigation = function (event) {

        let dismiss = false;

        // Dismiss when the window resizes
        if (event.type === 'change' && event.matches) {
            dismiss = true;
        }

        if (event.type === 'keyup' && event.key === 'Escape') {
            dismiss = true;
        }

        // Dismiss if clicked outside the premise
        if(event.type === 'pointerdown' && !event.target.closest('.js-present-nav')) {
            dismiss = true;
        }

        // Dismiss if the navigation loses focus
        if (event.type === 'keyup' && !event.target.closest('.js-present-nav')) {
            dismiss = true;
        }

        if (event.type === 'mouseleave' && !event.target.parentElement.contains(event.relatedTarget)) {
            dismiss = true;
        }

        if (dismiss) {

            for (const trigger of this.triggers) {
                trigger.firstElementChild.setAttribute('aria-expanded', 'false');
            }

            event.target.removeEventListener('mouseleave', this.dismissNavigation);
            window.removeEventListener('pointerdown', this.dismissNavigation);
            window.removeEventListener('keyup', this.dismissNavigation);
            this.breakpoint.removeEventListener('change', this.dismissNavigation);

            if (event.target.tagName === 'NAV') {
                event.target.removeEventListener('mouseleave', this.dismissNavigation);

            } else {
                event.target.nextElementSibling.removeEventListener('mouseleave', this.dismissNavigation);
            }
        }
    }

    const navigations = document.getElementsByClassName('js-present-nav');

    for (const navigation of navigations) {
        new PresentableNavigation(navigation);
    }
}());